<div class="fpx-form-control">
  <div class="slider-flex">
    <fpx-label *ngIf="label" [control]="formControl" [label]="label" ></fpx-label>
    <input matInput 
      type="tel"
      [prefix]="currencyCode + ' '" 
      [mask]="amountMaskFormat" 
      [thousandSeparator]="thousandSeparator" 
      autocomplete="off" [(ngModel)]="sliderValue"
      (input)="doValueChange($event)" />
  </div>
  <div class="fpx-field-content">
    <mat-slider class="mat-slider" [disabled]="disabled" [max]="max" [min]="min" [step]="step"
      [formControl]="formControl" (input)="updateRangeBar($event)" >
      <input matSliderThumb>
    </mat-slider>
    <div class="slider-flex">
      <span class="min-range"><strong>{{ min | mask : amountMaskFormat }}</strong> <em class="currency-code">{{ currencyCode }}</em></span>
      <span class="max-range"><strong>{{ max | mask : amountMaskFormat : thousandSeparator }}</strong> <em class="currency-code">{{ currencyCode }}</em></span>
    </div>
  </div>
  <mat-error *ngIf="formControl && formControl.invalid && formControl.touched">
    {{ errorCode }}
</mat-error>
</div>